import { forwardRef, useEffect, useState } from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '@ui/atoms/utils/utils';

const Slider = forwardRef(
    (
        {
            className,
            defaultValue = [0],
            valueClassName,
            onChange,
            value: propValue,
            hasRange = false,
            labelFormatter = (value) => value,
            showToolTip = false,
            ...props
        },
        ref
    ) => {
        const [value, setValue] = useState(propValue || defaultValue);
        useEffect(() => {
            setValue(propValue || defaultValue);
        }, [propValue]);
        return (
            <div className="flex flex-col h-6 justify-center">
                <SliderPrimitive.Root
                    ref={ref}
                    className={cn(
                        'relative flex w-full touch-none select-none items-center',
                        className
                    )}
                    value={value}
                    onValueChange={(val) => {
                        setValue(val);
                        onChange?.(val);
                    }}
                    {...props}
                >
                    <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-primary-70">
                        <SliderPrimitive.Range className="absolute h-full bg-primary-300" />
                    </SliderPrimitive.Track>
                    <SliderPrimitive.Thumb className="block w-6 h-6 transition-colors border rounded-full shadow border-primary-100 bg-primary-100 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50">
                        {showToolTip ? (
                            <div
                                className={cn(
                                    'absolute transform flex items-center -left-full -translate-x-1/2 transition-all',
                                    valueClassName
                                )}
                            >
                                <span className="ml-1 whitespace-nowrap">
                                    {' ' + ` ${labelFormatter(value)} `}
                                </span>
                            </div>
                        ) : null}
                    </SliderPrimitive.Thumb>
                </SliderPrimitive.Root>
            </div>
        );
    }
);
Slider.displayName = SliderPrimitive.Root.displayName;
export { Slider };